import {
  AddLandingPage,
  AddTheme,
  ADD_LANDING_PAGE,
  ADD_THEME,
  CREATE_LANDING_PAGE,
  CREATE_LANDING_PAGE_FAIL,
  CREATE_LANDING_PAGE_SUCCESS,
  LANDING_PAGE_CLEAR_ERROR,
} from './actions'
import { LandingPage, Theme } from '../../global/types'

export type LandingPageState = {
  isLoading: boolean
  showError: null | string
  data: Record<number, LandingPage[]>
}

type CreateLandingPage = {
  type: typeof CREATE_LANDING_PAGE
}

type CreateLandingPageSuccess = {
  type: typeof CREATE_LANDING_PAGE_SUCCESS
  message?: string
}

type CreateLandingPageFail = {
  type: typeof CREATE_LANDING_PAGE_FAIL
  message: string
}

type LandingPageClearError = {
  type: typeof LANDING_PAGE_CLEAR_ERROR
  message: string
}

const initialState: LandingPageState = {
  data: {},
  isLoading: false,
  showError: null,
}

export const reducer = (
  state = initialState,
  action:
    | CreateLandingPage
    | CreateLandingPageSuccess
    | CreateLandingPageFail
    | LandingPageClearError
    | AddLandingPage,
) => {
  switch (action.type) {
    case CREATE_LANDING_PAGE:
      return { ...state, isLoading: true }
    case CREATE_LANDING_PAGE_SUCCESS:
    case CREATE_LANDING_PAGE_FAIL:
      return { ...state, isLoading: false, showError: action.message || null }
    case ADD_LANDING_PAGE:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.landingPage.id]: action.landingPage,
        },
      }
    case LANDING_PAGE_CLEAR_ERROR:
      return { ...state, showError: null }
    default:
      return state
  }
}

export type ThemeState = {
  isLoading: boolean
  data: Record<number, Theme[]>
}

const initialThemeState: ThemeState = {
  data: {},
  isLoading: false,
}

export const themeReducer = (state = initialThemeState, action: AddTheme) => {
  switch (action.type) {
    case ADD_THEME:
      return {
        ...state,
        data: {
          ...state.data,
          [action.theme.id]: action.theme,
        },
      }
    default:
      return state
  }
}
